var exports = {
  "L": "xa15a2ab7--d52e87--fullscreen-button",
};

module.exports = exports;
